const CRIMSON_MAIL = {
  slug: "crimson-mail",
  name: "Crimson Mail",
  description: "Chainmail forged in volcanic fires",
  rarity: "common",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 8 },
    { stat: "redColor", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_red",
    frameIndex: 0
  },
  bodySprite: "characters/body/body_red",
  tags: ["daily-rotation", "metal"]
};
export {
  CRIMSON_MAIL
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9jcmltc29uLW1haWwudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbImltcG9ydCB7IEl0ZW1EZWZpbml0aW9uIH0gZnJvbSAnLi4vLi4vdHlwZXMnO1xuXG5leHBvcnQgY29uc3QgQ1JJTVNPTl9NQUlMOiBJdGVtRGVmaW5pdGlvbiA9IHtcbiAgc2x1ZzogJ2NyaW1zb24tbWFpbCcsXG4gIG5hbWU6ICdDcmltc29uIE1haWwnLFxuICBkZXNjcmlwdGlvbjogJ0NoYWlubWFpbCBmb3JnZWQgaW4gdm9sY2FuaWMgZmlyZXMnLFxuICByYXJpdHk6ICdjb21tb24nLFxuICBzbG90OiAnYXJtb3InLFxuICBzaG9wQ2F0ZWdvcnk6ICdtZXRhbC1hcm1vcicsXG4gIHN0YXRDaGFuZ2VzOiBbXG4gICAgeyBzdGF0OiAnYXJtb3InLCB2YWx1ZTogOCB9LFxuICAgIHsgc3RhdDogJ3JlZENvbG9yJywgdmFsdWU6IDMgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9yZWQnLFxuICAgIGZyYW1lSW5kZXg6IDAsXG4gIH0sXG4gIGJvZHlTcHJpdGU6ICdjaGFyYWN0ZXJzL2JvZHkvYm9keV9yZWQnLFxuICB0YWdzOiBbJ2RhaWx5LXJvdGF0aW9uJywgJ21ldGFsJ10sXG59O1xuIl0sCiAgIm1hcHBpbmdzIjogIkFBRU8sTUFBTSxlQUErQjtBQUFBLEVBQzFDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLFFBQVE7QUFBQSxFQUNSLE1BQU07QUFBQSxFQUNOLGNBQWM7QUFBQSxFQUNkLGFBQWE7QUFBQSxJQUNYLEVBQUUsTUFBTSxTQUFTLE9BQU8sRUFBRTtBQUFBLElBQzFCLEVBQUUsTUFBTSxZQUFZLE9BQU8sRUFBRTtBQUFBLEVBQy9CO0FBQUEsRUFDQSxRQUFRO0FBQUEsSUFDTixPQUFPO0FBQUEsSUFDUCxZQUFZO0FBQUEsRUFDZDtBQUFBLEVBQ0EsWUFBWTtBQUFBLEVBQ1osTUFBTSxDQUFDLGtCQUFrQixPQUFPO0FBQ2xDOyIsCiAgIm5hbWVzIjogW10KfQo=
